/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TaskstemplatesidTaskTemplate model module.
 * @module model/TaskstemplatesidTaskTemplate
 * @version v0.3
 */
export default class TaskstemplatesidTaskTemplate {
  /**
   * Constructs a new <code>TaskstemplatesidTaskTemplate</code>.
   * @alias module:model/TaskstemplatesidTaskTemplate
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TaskstemplatesidTaskTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TaskstemplatesidTaskTemplate} obj Optional instance to populate.
   * @return {module:model/TaskstemplatesidTaskTemplate} The populated <code>TaskstemplatesidTaskTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TaskstemplatesidTaskTemplate();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('action_type'))
        obj.actionType = ApiClient.convertToType(data['action_type'], 'String');
      if (data.hasOwnProperty('action_content'))
        obj.actionContent = ApiClient.convertToType(data['action_content'], Object);
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
      if (data.hasOwnProperty('cms_entry_id'))
        obj.cmsEntryId = ApiClient.convertToType(data['cms_entry_id'], 'String');
    }
    return obj;
  }
}

/**
 * Name of the task template
 * @member {String} name
 */
TaskstemplatesidTaskTemplate.prototype.name = undefined;

/**
 * Description of the task template
 * @member {String} description
 */
TaskstemplatesidTaskTemplate.prototype.description = undefined;

/**
 * External ID for this task template
 * @member {String} externalId
 */
TaskstemplatesidTaskTemplate.prototype.externalId = undefined;

/**
 * Allowed values for the <code>actionType</code> property.
 * @enum {String}
 * @readonly
 */
TaskstemplatesidTaskTemplate.ActionTypeEnum = {
  /**
   * value: "survey"
   * @const
   */
  survey: "survey",

  /**
   * value: "subscription_plan"
   * @const
   */
  subscriptionPlan: "subscription_plan",

  /**
   * value: "observation_type"
   * @const
   */
  observationType: "observation_type",

  /**
   * value: "appointment"
   * @const
   */
  appointment: "appointment",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * Type of action to be performed in order to complete the task
 * @member {module:model/TaskstemplatesidTaskTemplate.ActionTypeEnum} actionType
 */
TaskstemplatesidTaskTemplate.prototype.actionType = undefined;

/**
 * @member {Object} actionContent
 */
TaskstemplatesidTaskTemplate.prototype.actionContent = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
TaskstemplatesidTaskTemplate.prototype.tagList = undefined;

/**
 * Add a link to your CMS content
 * @member {String} cmsEntryId
 */
TaskstemplatesidTaskTemplate.prototype.cmsEntryId = undefined;

